import { TreePine, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <TreePine className="h-6 w-6 text-accent" strokeWidth={1.5} />
            <span className="font-heading text-2xl font-semibold">LAVista Stays<span className="text-accent">.com</span></span>
          </div>
          <p className="text-primary-foreground/70 max-w-sm leading-relaxed">
            Crafting eco-luxury living through imported pine wooden villas, thoughtful
            management, and end-to-end property services.
          </p>
        </div>

        <div>
          <h4 className="font-heading text-xl mb-4">Services</h4>
          <ul className="space-y-2 text-sm text-primary-foreground/70">
            <li>Rent-O-Villa</li>
            <li>Buy & Sell</li>
            <li>Design & Construction</li>
            <li>Legal Services</li>
            <li>Value-Added Services</li>
            <li>Safety Audits</li>
            <li>Insurance</li>
            <li>Mortgage & Loans</li>
            <li>Investment Advisor</li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-xl mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm text-primary-foreground/70">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-accent" /> hello@lavista.com</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-accent" /> +91 88501 15452</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-accent" /> Lonavla, Maharashtra</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-foreground/15 py-5 text-center text-xs text-primary-foreground/60">
        &copy; {new Date().getFullYear()} LAVista. All rights reserved. ·{" "}
        <a href="/terms" data-testid="footer-terms-link" className="hover:text-accent underline">Terms &amp; Conditions</a>
      </div>
    </footer>
  );
}
